import { DATE_KEYS } from 'legacyfrontend/constants';
import { formatWithMomentFormat } from 'legacyfrontend/utils/dateUtils';

export const normalizePassengersParam = (value) => {
  if (Array.isArray(value)) return value;
  if (!value) return [30];
  return String(value).split(',').map(Number);
};

export const parseFlightDateParam = (value) => {
  if (!value) return null;
  const [year, month, day] = String(value).split('-').map(Number);
  return new Date(year, month - 1, day, 12, 0, 0, 0);
};

export const formatFlightDateParam = (date) => {
  if (!date) return null;
  return formatWithMomentFormat(date, DATE_KEYS.FORMAT.ISO);
};

export const parseFlightSearchParams = (search) => {
  if (!search) return {};

  const urlParams = search instanceof URLSearchParams ? search : new URLSearchParams(search);
  const params = {};

  urlParams.forEach((value, key) => {
    params[key] = key === 'passengers' ? normalizePassengersParam(value) : value;
  });

  return params;
};

export const hasRequiredFlightSearchParams = (params) => {
  if (!params) return false;
  return !!(
    params.originId &&
    params.originName &&
    params.destinationId &&
    params.destinationName &&
    params.departureDate
  );
};

export const stripNonSearchParams = (search) => {
  if (!search) return '';

  const params = search instanceof URLSearchParams ? new URLSearchParams(search.toString()) : new URLSearchParams(search);
  params.delete('_refresh');
  params.delete('cache');
  return params.toString();
};

export const getEssentialFlightSearchKey = (search) => {
  if (!search) return '';

  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search);
  const essentialParams = new URLSearchParams();
  const essentialKeys = ['originId', 'destinationId', 'departureDate', 'isOnlyOneWay', 'passengers'];

  essentialKeys.forEach((key) => {
    const value = params.get(key);
    if (value) essentialParams.set(key, value);
  });

  const isOnlyOneWay = params.get('isOnlyOneWay');
  const returnDate = params.get('returnDate');
  if (returnDate && isOnlyOneWay !== 'true') {
    essentialParams.set('returnDate', returnDate);
  }

  return essentialParams.toString();
};

export const serializeFlightSearchParams = (input, { includeRefresh } = {}) => {
  const {
    origin,
    destination,
    departureDate,
    returnDate,
    passengers,
    isOnlyOneWay,
    currency,
    cache,
  } = input || {};

  const flightParams = new URLSearchParams();

  flightParams.set('departureDate', formatFlightDateParam(departureDate));

  if (returnDate && !isOnlyOneWay) {
    flightParams.set('returnDate', formatFlightDateParam(returnDate));
  }

  if (origin) {
    flightParams.set('originId', origin.cityCode);
    flightParams.set('originName', origin.cityName);
    if (origin.id && !isNaN(origin.id)) {
      flightParams.set('originIdn', origin.id);
    }
  }

  if (destination) {
    flightParams.set('destinationId', destination.cityCode);
    flightParams.set('destinationName', destination.cityName);
    if (destination.id && !isNaN(destination.id)) {
      flightParams.set('destinationIdn', destination.id);
    }
  }

  if (passengers && Array.isArray(passengers)) {
    flightParams.set('passengers', passengers.join(','));
  } else {
    flightParams.set('passengers', '30');
  }

  flightParams.set('isOnlyOneWay', isOnlyOneWay ? 'true' : 'false');

  if (currency) flightParams.set('currency', currency);

  flightParams.set('cache', cache);

  if (includeRefresh) {
    flightParams.set('_refresh', Date.now().toString());
  }

  return `?${flightParams.toString()}`;
};
